import Vue from 'vue'
import Router from 'vue-router'
import ltr from '@/pages/ltr'
import Index from '@/pages/index'
import Intro from '@/pages/intro'
import Greeting from '@/pages/greeting'
import Navbar from '@/components/navbar'

/* import Annualreport from '@/components/annual_report' */


import Team from '@/components/team'
import Package from '@/components/package'
import Testimonial from '@/components/testimonial'
import FAQ from '@/components/faq'
import Blog from '@/components/blog'
import Subscribe from '@/components/subscribe'
import Copyright from '@/components/copy_right'
import Screenshots from '@/components/screenshots'
import AppCardSlider from '@/components/AppCardSlider'

/* import Slider from '@/components/slider'
import About from '@/components/about'
import Feature from '@/components/feature'
import Work from '@/components/work'

import Download from '@/components/download'
import Footer from '@/components/footer' */

// blog pages
/* import Bloglist from '@/demo_pages/blog_list'
import Blogdetails from '@/demo_pages/blog_details'
import Blogsleftside from '@/demo_pages/blogs_leftside'
import Blogsrightside from '@/demo_pages/blogs_rightside'
import Blogleftsidebar from '@/demo_pages/blog_details_left_sidebar'
import Blogrightsidebar from '@/demo_pages/blog_details_right_sidebar'
import Pagenotfound from '@/other_pages/pagenotfound'

import Signup from '@/other_pages/signup'
import Signin from '@/other_pages/signin'
import Forgotpassword from '@/other_pages/forgot_password'
import Thankyou from '@/other_pages/thank_you'
import Review from '@/other_pages/review'
import FAQpage from '@/other_pages/FAQ_page'
import Comingsoon from '@/other_pages/coming_soon'
import Downloadpage from '@/other_pages/download'
import Request from '@/other_pages/request'
 */


// blog pages
/* import Bloglistrtl from '@/rtl/demo_pages/blog_list'
import Blogdetailsrtl from '@/rtl/demo_pages/blog_details'
import Blogsleftsidertl from '@/rtl/demo_pages/blogs_leftside'
import Blogsrightsidertl from '@/rtl/demo_pages/blogs_rightside'
import Blogleftsidebarrtl from '@/rtl/demo_pages/blog_details_left_sidebar'
import Blogrightsidebarrtl from '@/rtl/demo_pages/blog_details_right_sidebar'
 */
// Other pages
/* import Signuprtl from '@/rtl/other_pages/signup'
import Signinrtl from '@/rtl/other_pages/signin'
import Forgotpasswordrtl from '@/rtl/other_pages/forgot_password'
import Thankyourtl from '@/rtl/other_pages/thank_you'
import Reviewrtl from '@/rtl/other_pages/review'
import FAQpagertl from '@/rtl/other_pages/FAQ_page'
import Comingsoonrtl from '@/rtl/other_pages/coming_soon'
import Downloadpagertl from '@/rtl/other_pages/download'
import Requestrtl from '@/rtl/other_pages/request'
import Pagenotfoundrtl from '@/rtl/other_pages/pagenotfound' */

Vue.use(Router)
Vue.component('Navbar', Navbar)


/* Vue.component('Slider', Slider)
Vue.component('About', About)
Vue.component('Feature', Feature)
Vue.component('Work', Work)
Vue.component('Screenshots', Screenshots)
Vue.component('Bloglist', Bloglist)
Vue.component('Footer', Footer)
Vue.component('Download', Download) */

Vue.component('Team', Team)
Vue.component('Package', Package)
Vue.component('Testimonial', Testimonial)
Vue.component('FAQ', FAQ)
Vue.component('Blog', Blog)
Vue.component('Subscribe', Subscribe)
Vue.component('Copyright', Copyright)
Vue.component('Screenshots', Screenshots)
Vue.component('AppCardSlider', AppCardSlider)



export default new Router({
  mode: 'history',
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      redirect: '/Greeting'
    },
    {
      path: '/intro',
      name: 'Intro',
      components: {
        default: Intro
      }
    },
    {
      path: '*',
      redirect: '/404'
    },
    {
      path: '/',
      // You could also have named views at the top
      components: {
        default: ltr
      },
      children: [{
        path: 'Greeting',
        name: 'Greeting',
        components: {
          default: Greeting,
        }
      },
      {
        path: 'Exhibition',
        name: 'Index',
        components: {
          default: Index,
          navbar: Navbar
        }
      }/* ,
      {
        path: 'blog-list',
        name: 'Bloglist',
        components: {
          default: Bloglist,
          navbar: Navbarblog
        }
      } ,
      {
        path: 'blog-details',
        name: 'Blogdetails',
        components: {
          default: Blogdetails,
          navbar: Navbarblog
        }
      },
      {
        path: 'blogs-leftside',
        name: 'Blogsleftside',
        components: {
          default: Blogsleftside,
          navbar: Navbarblog
        }
      },
      {
        path: 'blogs-rightside',
        name: 'Blogsrightside',
        components: {
          default: Blogsrightside,
          navbar: Navbarblog
        }
      },
      {
        path: 'blog-details-with-left-sidebar',
        name: 'Blogleftsidebar',
        components: {
          default: Blogleftsidebar,
          navbar: Navbarblog
        }
      },
      {
        path: 'blog-details-with-right-sidebar',
        name: 'Blogrightsidebar',
        components: {
          default: Blogrightsidebar,
          navbar: Navbarblog
        }
      },
      {
        path: 'sign-up',
        name: 'Signup',
        component: Signup
      },
      {
        path: 'sign-in',
        name: 'Signin',
        component: Signin
      },
      {
        path: 'forgot-password',
        name: 'Forgotpassword',
        component: Forgotpassword
      },
      {
        path: 'review',
        name: 'Review',
        components: {
          default: Review,
          navbar: Navbarblog
        }
      },
      {
        path: 'thank-you',
        name: 'Thankyou',
        component: Thankyou
      },
      {
        path: 'FAQ-page',
        name: 'FAQpage',
        components: {
          default: FAQpage,
          navbar: Navbarblog
        }
      },
      {
        path: 'download',
        name: 'Downloadpage',
        component: Downloadpage
      },
      {
        path: 'coming-soon',
        name: 'Comingsoon',
        component: Comingsoon
      },
      {
        path: 'request',
        name: 'Request',
        components: {
          default: Request,
          navbar: Navbarblog
        }
      }*/
      ]},
    // rtl strat form hear
    
  ]
})
